const variables = {
    black: "#000000",
    background: "#0F0E17",
    primary: "#FED941",
    grey: "#A7A9BE",
    white: "#FFFFFE",
    fontPrimary: `"Montserrat", sans-serif`,
    fontSecondary: `'Inter', sans-serif`,
}
export  default variables